import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { BookingSessionResponse, SubmitInsuranceRequest } from '../../types/booking-session.js'

import { apiClient } from '../../lib/client.js'
import { syncBookingSessionCache } from './cache.js'
import { bookingSessionKeys } from './keys.js'

export const useSubmitInsurance = (
  sessionId: string,
  { throwOnError = false }: { throwOnError?: boolean }
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: SubmitInsuranceRequest) => {
      const response = await apiClient.client.post<BookingSessionResponse>(
        `/booking-session/${sessionId}/insurance`,
        data
      )
      return response.data
    },
    onSuccess: (data) => {
      syncBookingSessionCache(queryClient, data)
      queryClient.setQueryData(bookingSessionKeys.insuranceEstimate(sessionId), data)
    },
    throwOnError,
  })
}
